var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import cookie from '../../cookie/cookie';
import { COMMONGIFTURL, SYSTEMINSTRUCTION } from '../../constant/common-gift';
export default Vue.extend({
    name: 'topMenu',
    computed: __assign({}, mapState('common', {
        unviewNum: 'unviewNum',
    }), mapState('user', {
        topMenuList: 'topMenuList',
    }), { systemInstructionUrl: function () {
            return "" + COMMONGIFTURL + SYSTEMINSTRUCTION;
        },
        unviewNumTxt: function () {
            return this.unviewNum < 100 ? this.unviewNum : '···';
        },
        dafs_type: function () {
            return cookie.getCookie('dafs_type');
        } }),
    data: function () {
        return {
            flag: false,
            showLoginInfo: false,
        };
    },
    props: {
        name: {
            type: String,
            default: '',
        },
    },
    created: function () {
        // 获取未读消息数量
        this.$store.dispatch('common/GET_UNVIEWCOUNT');
    },
    methods: {
        logout: function () {
            var _this = this;
            this.$omega.trackEvent('dasf_kzt_dropoutclick_pv');
            this.$request({
                method: 'post',
                url: '/proxy/logout/merchant/passport/operator/logout',
                data: {},
            }).then(function (res) {
                if (!res) {
                    return;
                }
                if (!res.errno) {
                    cookie.setCookie({
                        usernameZh: '',
                    }, -1);
                    _this.$message({
                        message: '您已安全登出',
                        type: 'success',
                    });
                    setTimeout(function () {
                        window.location.reload();
                    }, 1000);
                }
            });
        },
        goHome: function () {
            this.$omega.trackEvent('dasf_kzt_shouyeclick_pv');
            this.$router.push({
                path: '/',
            });
        },
        openMsgList: function () {
            this.$omega.trackEvent('dasf_kzt_menuclick', {
                name: 'message_list',
                position: 'top',
            });
            this.$store.commit('common/update', {
                isOpenMsgListModel: true,
            });
        },
        toggleStatus: function (flag) {
            this[flag] = !this[flag];
        },
        sendOmega: function (name) {
            this.$omega.trackEvent('dasf_kzt_menuclick', {
                name: name,
                position: 'top',
            });
        },
        getCurrentOmega: function () {
            this.$omega.trackEvent('dasf_kzt_zhxxclick_pv');
        },
        sendOmegaGuide: function () {
            this.$omega.trackEvent('dasf_kzt_guideclick');
        },
    },
});
